import React, {FC} from 'react'
import {KTSVG} from '../../../helpers'

interface DrawerComponentsInterface {
  id: string
  title: string
  width: {
    md: number
    lg: number
    xl?: number
  }
}

const DrawerComponents: FC<DrawerComponentsInterface> = ({
                                                           id,
                                                           title,
                                                           width: {md, lg, xl = 1500},
                                                           children,
                                                         }) => {

  return (
    <div
      id={`kt_drawer_${id}`}
      className="bg-white"
      data-kt-drawer="true"
      data-kt-drawer-name="chat"
      data-kt-drawer-activate="true"
      data-kt-drawer-overlay="true"
      data-kt-drawer-width={`{default:'300px', 'md': '${md}px', 'lg': '${lg}px', 'xl': '${xl}px'}`}
      data-kt-drawer-direction="end"
      data-kt-drawer-toggle={`#kt_drawer_${id}_toggle`}
      data-kt-drawer-close={`#kt_drawer_${id}_close`}
    >
      <div className="card w-100 rounded-0" id={`kt_drawer_${id}_card`}>
        <div className="card-header pe-5" id={`kt_drawer_${id}_card_header`}>
          <div className="card-title">
            <div className="d-flex justify-content-center flex-column me-3">
                <span className="fs-4 fw-bolder text-gray-900 me-1 mb-2 lh-1">
                  {title}
                </span>
            </div>
          </div>

          <div className="card-toolbar">
            <div className="btn btn-sm btn-icon btn-active-light-primary"
                 id={`kt_drawer_${id}_close`}
            >
              <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-2" />
            </div>
          </div>
        </div>

        <div className="card-body" id={`kt_drawer_${id}_card_body`}>
          {children}
        </div>
      </div>
    </div>
  )
}

export {DrawerComponents}